import { get } from './method';
import * as routes from '@configs/routes.json';
import { IDownloadResultsPackageAPIResponse } from '../models/results';

export const getDownloadResultsPackage = async (
  id: string
): Promise<IDownloadResultsPackageAPIResponse> => {
  const url = routes.api.reports.downloadReportsPackage.replace(':id', id);
  return get(url).then((resp) => resp.json());
};
